// @ts-ignore
import { transform, set, camelCase, snakeCase, } from 'lodash';
// @ts-ignore
import { isArray, isObjectLike, isPlainObject, map, } from 'lodash/fp';

function createIteratee(converter: Function, self: Function) {
    return (result: any, value: any, key: string) => set(result, converter(key), isObjectLike(value) ? self(value) : value);
}

export function createTransformer(keyConverter: Function) {
    return function humps(node: Function) {
        if (isArray(node)) {
            return map(humps, node);
        }
        if (isPlainObject(node)) {
            return transform(node, createIteratee(keyConverter, humps));
        }
        return node;
    };
}

export function camelCaseObject(obj: any) {
    return createTransformer(camelCase)(obj);
}

export function snakeCaseObject(obj: any) {
    return createTransformer(snakeCase)(obj);
}
